import { useQuery } from '@tanstack/react-query';
import { goChatService, ensureChatTokenForUser } from '../services/goChatApi';
import { useAuth } from './useAuth';

/**
 * Cuenta conversaciones con unreads contra Go-chat + indica si el servicio
 * responde. Polling cada 60s. Si Go está caído o el user no está logueado
 * devolvemos { count: 0, available: false } — el sidebar puede usar
 * `available` para esconder la pestaña Mensajes y no exponer un link roto.
 */
export function useUnreadMessages() {
  const { user } = useAuth();

  const { data, isSuccess } = useQuery({
    queryKey: ['go-chat', 'unread-count'],
    queryFn: async () => {
      // Sin esto, si quedó en localStorage un chat token de una sesión
      // previa (otro user), el badge mostraría unreads de ESE user — Go
      // autoriza por JWT y no nota el cambio de usuario en Spring.
      await ensureChatTokenForUser(user.id);
      const res = await goChatService.getUserConversations();
      const list = Array.isArray(res?.data) ? res.data : (res?.data?.data || []);
      return list.filter((c) => c?.hasUnread).length;
    },
    enabled: !!user,
    staleTime: 30_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    retry: false,
  });

  return { count: isSuccess ? (data || 0) : 0, available: isSuccess };
}
